import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';
import CreatorComponent from '../../Content/CreatorComponent/CreatorComponent';
import ContentSnipper from '../../Wrappers/ContentSnipper/ContentSnipper';
import './Comment.scss';

export const charactersPerMode = {
    truncated: {
        sentences: 0,
        characters: 221,
    },
    full: {
        sentences: 0,
        characters: 0,
    },
    truncatedWithLink: {
        sentences: 0,
        characters: 150,
    },
};

export default class Comment extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * The text to be displayed as a comment
         */
        comment: PropTypes.string.isRequired,
        /**
         * Extra class names
         */
        className: PropTypes.string,
        /**
         * An author object, see AuthorDisplay component
         */
        author: PropTypes.object,
        /**
         * truncated or full
         */
        mode: PropTypes.string,
        /**
         * a hyperlink when the discussion is clicked
         */
        href: PropTypes.string,
        /**
         * Whether or not the comment has more replies
         */
        hasMore: PropTypes.string,
        /**
         * The hash identity of the comment
         */
        hash: PropTypes.string.isRequired,
        /**
         * whether user chose to be anonymous
         */
        isAnonymous: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
        /**
         * reactionbar
         */
        reactionBar: PropTypes.node.isRequired,
        /**
         * Formatted date of last user comment activity
         */
        formattedLastEdit: PropTypes.string,
        truncateWithLink: PropTypes.bool,
    };

    static defaultProps = {
        mode: 'full',
        className: '',
        isAnonymous: 0,
    };

    renderMoreLink = () => <span className="more-link">More...</span>;
    renderCommentSection = () => {
        const sentencesForContentSnipper =
            charactersPerMode[this.props.mode].sentences;
        const charactersForContentSnipper =
            charactersPerMode[this.props.mode].characters;
        return (
            <React.Fragment>
                <CreatorComponent
                    author={this.props.author}
                    contentHash={this.props.hash}
                    formattedTimestamp={this.props.createdDate}
                />
                <div className="comment-text-display">
                    {this.props.truncateWithLink ? (
                        truncateWithEllipsis(this.props.comment, 150, false)
                    ) : (
                        <ContentSnipper
                            sentences={sentencesForContentSnipper}
                            characters={charactersForContentSnipper}
                            truncateWithLink={this.props.truncateWithLink}
                        >
                            {this.props.comment}
                        </ContentSnipper>
                    )}
                    {this.props.truncateWithLink &&
                    this.props.comment.length > 150
                        ? this.renderMoreLink()
                        : null}
                    {this.props.formattedLastEdit && (
                        <div className="moderated-comment-timestamp">
                            {this.props.formattedLastEdit}
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    };

    render() {
        const comment = this.renderCommentSection();
        return (
            <div
                id={'link-id-' + this.props.hash}
                className={`component-Content-Sections-Comment ${this.props.className}`}
            >
                {this.props.isInMasterFeed ? (
                    <a
                        href={`${this.props.parentUrl}#reactbar-${this.props.hash}`}
                        className={'linked-comment'}
                    >
                        {comment}
                    </a>
                ) : (
                    comment
                )}
                {this.props.reactionBar}
            </div>
        );
    }
}
